import React from "react";
import {
  FaLaptopCode,
  FaShieldAlt,
  FaCoins,
  FaLayerGroup,
} from "react-icons/fa";

function DeFiSolutions() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className="col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Our Polygon zkEVM Development Services
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLaptopCode size={30} />
                      </div>
                      <h4>Custom DApp Development</h4>
                      <p>
                        We create Ethereum-compatible, highly scalable DApps
                        using Polygon zkEVM, ensuring faster, cost-effective
                        operations with zero-knowledge rollup technology.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaShieldAlt size={30} />
                      </div>
                      <h4>Smart Contract Development & Audit</h4>
                      <p>
                        Xeer’s developers craft robust smart contracts and
                        provide thorough security audits, ensuring reliability
                        and efficiency on Polygon zkEVM.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={30} />
                      </div>
                      <h4>Zero-Knowledge Rollups Implementation</h4>
                      <p>
                        Our team implements zero-knowledge rollups, reducing
                        transaction costs and latency, and supporting high
                        transaction throughput.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLayerGroup size={30} />
                      </div>
                      <h4>NFT Marketplace Development</h4>
                      <p>
                        Leverage Polygon zkEVM’s efficiency with Xeer’s
                        custom-built NFT marketplaces, offering secure,
                        scalable, and cost-effective trading solutions for
                        digital assets.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={30} />
                      </div>
                      <h4>DeFi Solutions</h4>
                      <p>
                        We develop DeFi platforms with Polygon zkEVM,
                        integrating staking, lending, and yield farming for
                        optimized user experiences and lower transaction fees.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLayerGroup size={30} />
                      </div>
                      <h4>Cross-Chain Solutions</h4>
                      <p>
                        Xeer Technology enables interoperability with other
                        blockchains, using Polygon zkEVM for cross-chain
                        bridges, ensuring secure asset transfers and data
                        exchange.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeFiSolutions;
